module.exports = __webpack_public_path__ + "img/20180815_154807_247.eee77ad3.jpg";